/*
  if Fullstory is not enabled, replace the FS module with empty functions
*/
const fullstory = window.FS != null ? window.FS : { identify: () => {} };

export const setUserProperties = (userId, properties) => {
  fullstory.identify(userId, {...properties});
};
